import script from "./ProVenueMoments.vue?vue&type=script&setup=true&lang=js"
export * from "./ProVenueMoments.vue?vue&type=script&setup=true&lang=js"

import "./ProVenueMoments.vue?vue&type=style&index=0&id=092ec707&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-092ec707"]])

export default __exports__